export const InvoiceMeetingAction = {
    AddInvoiceMeeting: "ADDINVOICEMEETING",
    RemoveInvoiceMeeting: "REMOVEINVOICEMEETING",
    RemoveAllInvoiceMeeting: "REMOVEALLINVOICEMEETING"
}



const InvoiceMeeting = [];

const InvoiceMeetingsReducer = (InvMeeting = InvoiceMeeting, actions) => {
    switch (actions.type) {
        case InvoiceMeetingAction.AddInvoiceMeeting:
            //  return { ...updtGoals, ...actions.payload };
            InvMeeting.push(actions.payload);
            return InvMeeting;
        case InvoiceMeetingAction.RemoveInvoiceMeeting:
            // updtGoals = [];
            var res = InvMeeting.filter((item) => item.Id !== actions.payload);
            InvMeeting = [];
            InvMeeting = res;
            return InvMeeting;
        case InvoiceMeetingAction.RemoveAllInvoiceMeeting:
            var res = [];
            InvMeeting = res;
            return InvMeeting;

        default:
            // updtInvCont = [];
            return InvMeeting;
    }
}
export default InvoiceMeetingsReducer;